<template>
  <div class="p-3 bg-white border-top border-bottom border-gray-03">
    <div>
      <h3 class="text-size-14 text-weight-500 text-primary-dark">責任者</h3>
      <GreetingMessage
        class="mt-2"
        :firstName="getOfficeProp('managerFirstName')"
        :lastName="getOfficeProp('managerLastName')"
        :personImage="managerAvatar"
        :message="getOfficeProp('greetingMessage')"
      />
    </div>

    <div class="mt-3">
      <h3 class="text-size-14 text-weight-500 text-primary-dark">
        仕事内容
      </h3>
      <div class="operation-tags">
        <Tag
          v-for="operation in operations"
          :key="operation.id"
          data-testid="operations"
          :label="operation.name"
          class="bg-light-yellow border-yellow text-primary-dark"
        />
      </div>

      <slot v-if="operations.length === 0" name="unsetOperations" />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { OrderDetail, SlimOrder } from "@/types/order/Order";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import GreetingMessage from "@/components/molecules/other/GreetingMessage.vue";
import Tag from "@/components/atoms/other/Tag.vue";

@Component({
  components: {
    FeatherIcon,
    GreetingMessage,
    Tag
  }
})
export default class OrderIntroContents extends Vue {
  @Prop({
    type: Object,
    required: true
  })
  orderDetail!: OrderDetail;

  @Prop({
    type: Array,
    default: null
  })
  sameTemplateOrderDates!: string[] | null;

  get operations() {
    if (!this.orderDetail?.operations) return [];
    return this.orderDetail.operations;
  }

  get managerAvatar() {
    return this.orderDetail?.office.managerAvatar || null;
  }

  get selectedDates() {
    return [this.orderDetail?.date];
  }

  get orderListLink() {
    return {
      name: "SearchByOffice",
      params: {
        officeId: `${this.orderDetail.office.id}`
      },
      hash: "#orderList"
    };
  }

  getOfficeProp(fieldName: string) {
    if (!this.orderDetail?.office) return null;
    return this.orderDetail.office[
      fieldName as keyof typeof this.orderDetail.office
    ];
  }
}
</script>

<style lang="scss" scoped>
.order-list-link {
  display: flex;
  justify-content: center;
  padding: 10px 0;
  margin-top: 20px;
  cursor: pointer;
  background-color: $gray-06;
  border: 1px solid $gray-03;
  border-radius: 4px;
}

.order-list-link-text {
  font-size: 14px;
  font-weight: 500;
  color: $gray-900;
}

.operation-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-content: center;
  align-items: center;
  margin-top: 8px;
}

.chevron-icon {
  margin-left: auto;
}
</style>
